import { getNextContentId } from './contentIds';

export const MEDIA_BLOCK_TYPES = Object.freeze([
  'post_pictures',
  'post_artworks',
  'post_videos',
]);

const blockKey = block => `${block.type}:${block.id}`;

export function insertContentBlock(structure, block, afterBlockKey) {
  const nextStructure = (structure || []).filter(
    current => blockKey(current) !== blockKey(block)
  );
  const insertionIndex = nextStructure.findIndex(
    current => blockKey(current) === afterBlockKey
  );

  if (insertionIndex === -1) return [...nextStructure, block];

  nextStructure.splice(insertionIndex + 1, 0, block);
  return nextStructure;
}

export function removeContentBlock(structure, type, id) {
  return (structure || []).filter(
    block => block.type !== type || block.id !== id
  );
}

export function updateTextBlock(texts, textId, content) {
  const currentTexts = texts || [];
  const currentText = currentTexts.find(text => text.textId === textId);

  if (!currentText || currentText.content === content) return currentTexts;

  return currentTexts.map(text => (
    text.textId === textId ? { ...text, content } : text
  ));
}

export function addEmptyTextBlock(content) {
  const textId = getNextContentId(content.post_texts, 'textId');
  const textBlock = { textId, content: '<div><br></div>' };

  return {
    textId,
    post_texts: [...content.post_texts, textBlock],
  };
}

export function contentBlockKey(type, id) {
  return `${type}:${id}`;
}
